import { FormControl, Grid, ThemeSpaceVariable, ToggleButton } from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { InputGroup } from "@chakra-ui/react";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";
import { ClickIdBuilders } from "logger/click-tracking";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { useTranslation } from "react-i18next";

export const SelectChildren = () => {
    const { t } = useTranslation();
    const state = useBookingStateContext();
    const { setChildren } = useBookingActionsContext();

    const { guests } = state;

    // Track children selection step
    useStepTracking({
        stepName: TrackingStepName.ChildrenStep,
        autoTrack: true,
    });

    usePageTracking({
        pageName: "SelectChildren",
        pageType: PageType.WizardStep,
        metadata: {
            totalGuests: guests,
        },
    });

    const handleGuestsChildrenChange = (guestsChildren: number) => setChildren?.(guestsChildren);

    return (
        <FormControl key="guest-children" id="guestsChildren">
            <InputGroup>
                <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Small} width="100%">
                    {[...Array(guests).keys()].map((children) => {
                        return (
                            <ToggleButton
                                key={children}
                                w="100%"
                                size="lg"
                                gridColumn={!children ? "span 2" : ""}
                                onClick={() => handleGuestsChildrenChange(children)}
                                data-track-click={ClickIdBuilders.selectChildren(children)}
                            >
                                {!children ? t("start.ofWhichNone") : children}
                            </ToggleButton>
                        );
                    })}
                </Grid>
            </InputGroup>
        </FormControl>
    );
};
